import { render } from "./lifeCycles.vue?vue&type=template&id=31adc729&scoped=true&ts=true"
import script from "./lifeCycles.vue?vue&type=script&lang=ts"
export * from "./lifeCycles.vue?vue&type=script&lang=ts"

import "./lifeCycles.vue?vue&type=style&index=0&id=31adc729&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31adc729"]])

export default __exports__